import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AuthServiceService } from '../auth-service.service';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  imports: [
    NgxSkeletonLoaderModule,
    NgIf
  ],
  styleUrls: ['./token.component.scss']
})
export class TokenComponent implements OnInit {
  bhAuthError = false;
  datacenter: string;

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthServiceService) {
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.datacenter = this.route.snapshot.params['dataCenter'];
      const redirectRoute = sessionStorage.getItem(`authPostRedirectUrl`) ?? '/';
      if (params.get('err') === 'bhconn') {
        this.bhAuthError = true;
        return;
      }

      const token = params.get('token');
      this.authService.startAuth();
      this.authService.setToken(token);
      this.router.navigate([redirectRoute]);
    });
  }
}
